import { createAction } from 'redux-actions';

const smartfillActions = {
  UPDATE_SMARTFILL_DATA: 'UPDATE_SMARTFILL_DATA',
  UPDATE_SMARTFILL_FAILED: 'UPDATE_SMARTFILL_FAILED',
  UPDATE_SMARTFILL_COMPLETED: 'UPDATE_SMARTFILL_COMPLETED',
  FETCH_SMARTFILL: 'FETCH_SMARTFILL',
};

const actionCreators = {
  fetchSmartfillData: createAction(smartfillActions.UPDATE_SMARTFILL_DATA),
  fetchSmartfillDataFailed: createAction(
    smartfillActions.UPDATE_SMARTFILL_FAILED
  ),
  fetchSmartfillDataCompleted: createAction(
    smartfillActions.UPDATE_SMARTFILL_COMPLETED
  ),
  fetchSmartfill: createAction(smartfillActions.FETCH_SMARTFILL),
};

export { smartfillActions as types, actionCreators };
